<script setup>
</script>
<template>
   <section class="container 2xl:px-24 xl:px-0">
    <div class="relative w-full h-full top-14 py-20 xl:py-60 lg:py-48 md:py-28 sm:py-28 overflow-hidden">
            <VLazyImage src="/assets/images/services/our-service.webp" alt="blogs page" class="absolute inset-0 object-cover w-full h-full" />
        </div>
    </section>
</template>
<style scoped>
</style>
